export const dataURItoBlob = (dataURI) => {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1]);
    else
        byteString = unescape(dataURI.split(',')[1]);
    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], {type:mimeString});
};

export const cropToImgFile = ({ crop, image }) => {
  const imageWidth = image.width;
  const imageHeight = image.height;

  const cropX = (crop.x / 100) * imageWidth;
  const cropY = (crop.y / 100) * imageHeight;

  const cropWidth = (crop.width / 100) * imageWidth;
  const cropHeight = (crop.height / 100) * imageHeight;

  const canvas = document.createElement('canvas');
  canvas.width = cropWidth;
  canvas.height = cropHeight;
  const ctx = canvas.getContext('2d');

  ctx.drawImage(image, cropX, cropY, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);

  const src = canvas.toDataURL('image/jpeg');
  return new File([dataURItoBlob(src)], 'newImage', { type: 'image/jpeg', lastModified: Date.now() });
};



// WEBPACK FOOTER //
// ./src/components/Profile/AvatarUploader/utils.js